'use strict'
/**
 * 都道府県コード定義
 * 八地方区分、および都道府県のコードを定義します。
 */

/**
 * エリアコード定義
 * 八地方区分のコードを定義します。
 */
const AREA_CD = {
  KANTO: 1,
  KANSAI: 2,
  SHINETSU: 3,
  CHUBU: 4,
  KYUSHU: 5
}

/**
 * 都道府県コード定義
 * 都道府県のコードを定義します。
 */
const PREF_CD = {
  TOKYO: 1,
  KANAGAWA: 2,
  SAITAMA: 3,
  CHIBA: 4,
  GUNMA: 5,
  IBARAKI: 6,
  OSAKA: 7,
  SHIGA: 8,
  AICHI: 9,
  GIHU: 10,
  HUKUOKA: 11
}

export { AREA_CD, PREF_CD }



// WEBPACK FOOTER //
// ./src/lib/prefecture_code/code.js